import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BreakPointService, Device, FeatureService } from '@woolworthsnz/styleguide';
import { SortOptionItem } from '@woolworthsnz/trader-api';
import { SearchMediatorService } from '../search-mediator.service';

@Component({
	// tslint:disable-next-line:component-selector
	selector: 'search-header, [searchHeader]',
	template: ``,
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true
})
export class SearchHeaderComponent {
	@Input() heading = 'Listing heading';
	@Input() sortOptions: SortOptionItem[] = [];
	@Input() currentSortOption?: SortOptionItem | string;
	@Input() totalItems: number;

	// eslint-disable-next-line @angular-eslint/no-output-on-prefix
	@Output() onSortChange: EventEmitter<string> = new EventEmitter();

	device = Device;

	constructor(
		protected featureService: FeatureService,
		public breakPointService: BreakPointService,
		protected searchMediatorService: SearchMediatorService
	) { }

	handleSortChange(sortValue: string): void {
		this.searchMediatorService.emitSortChangeEvent(sortValue);
	}
}
